import React, { Component } from 'react';
import Slider from 'react-slick';
import ArrowButton from '../ui/ArrowButton';
import RectButton from '../ui/RectButton';
import style from './SliderWithText.module.scss';
import { Lazy } from 'react-lazy';

import { CSSPlugin } from 'gsap/CSSPlugin';
import { TweenLite } from 'gsap';

const plugins = [CSSPlugin];

const LazyImage = ({
  handleOnLoad,
  handleInView,
  image,
  wrapperClass,
  isLoaded,
}) => {
  // console.log(Math.min(image.height / image.width, 480 / 640));
  return (
    <Lazy
      onViewport={handleInView}
      threshold={[0.66]}
      onLoad={handleOnLoad}
      className={wrapperClass}
      style={{
        paddingBottom: `${Math.min(image.height / image.width, 480 / 640) *
          100}%`,
        height: 0,
        position: 'relative',
      }}
    >
      <img
        src={`${image.sizes ? image.sizes.medium_large : image.url}`}
        alt={image.alt}
        className={style.slideImage}
      />
    </Lazy>
  );
};

const SlideShow = ({
  images,
  options,
  handleInView,
  handleOnLoad,
  isLoaded,
}) => {
  return (
    <Slider className={`timeline-slick ${style.slideshow}`} {...options}>
      {images.map((image, index) => {
        if (index === 0) {
          return (
            <LazyImage
              key={`${image.title}-${index}`}
              image={image}
              handleOnLoad={handleOnLoad}
              handleInView={handleInView}
              wrapperClass={style.slideImageWrap}
            />
          );
        } else {
          return (
            <div
              key={`${image.title}-${index}`}
              className={style.slideImageWrap}
            >
              <div
                style={{
                  paddingBottom: `${Math.min(
                    image.height / image.width,
                    480 / 640
                  ) * 100}%`,
                  height: 0,
                  position: 'relative',
                }}
              >
                <img
                  src={`${image.sizes ? image.sizes.medium_large : image.url}`}
                  alt={image.alt}
                  className={style.slideImage}
                />
              </div>
            </div>
          );
        }
      })}
    </Slider>
  );
};
class SliderWithText extends Component {
  state = {
    isLoaded: false,
    isEntered: false,
  };

  animateInView = () => {
    TweenLite.to(this.itemRef, 1.2, {
      autoAlpha: 1,
      y: '0%',
      ease: Quad.easeInOut,
    });
  };

  handleInView = event => {
    if (
      event.isIntersecting &&
      !this.state.isEntered &&
      this.itemRef &&
      this.props.eraInView
    ) {
      this.state.isLoaded &&
        this.setState(
          { isEntered: !this.state.isEntered },
          this.animateInView()
        );
    }
  };

  handleOnLoad = () => {
    this.setState(
      { isLoaded: true },
      this.handleInView({ isIntersecting: true })
    );
  };

  componentDidMount() {
    if (this.itemRef) {
      TweenLite.set(this.itemRef, { autoAlpha: 0, y: '5%' });
    }
  }

  render() {
    const slickOptions = {
      dots: true,
      infinite: false,
      arrows: true,
      speed: 1000,
      cssEase: 'cubic-bezier(.9, 0, .3, 1)',
      nextArrow: <ArrowButton direction={'right'} />,
      prevArrow: <ArrowButton direction={'left'} />,
    };
    const { title, body, color_toggle, images, cta } = this.props;
    if (!images[0].url) {
      return null;
    }
    return (
      <div ref={el => (this.itemRef = el)} className={style.slideshowWrapper}>
        {images.length > 1 ? (
          <SlideShow
            options={slickOptions}
            images={images}
            handleInView={this.handleInView}
            handleOnLoad={this.handleOnLoad}
            isLoaded={this.state.isLoaded}
          />
        ) : (
          <LazyImage
            image={images[0]}
            handleOnLoad={this.handleOnLoad}
            handleInView={this.handleInView}
            wrapperClass={style.imageWrap}
            isLoaded={this.state.isLoaded}
          />
        )}
        {title && (
          <div
            className={`${color_toggle ? style.slideshowTitleRed : ''} ${
              style.slideshowTitle
            }`}
          >
            <h4 dangerouslySetInnerHTML={{ __html: title }} />
          </div>
        )}
        {body && (
          <p
            className={style.slideshowBody}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        )}
        {cta && (
          <RectButton
            path={cta[0].path}
            buttonText={cta[0].text}
            externalLink={cta[0].externalLink}
          />
        )}
      </div>
    );
  }
}

export default SliderWithText;



// WEBPACK FOOTER //
// ./src/components/global/SliderWithText.js